import { defineMessages } from 'react-intl';

export default defineMessages({
    modalTitle: {
        id: 'adac.header.modal-contact-adac.ADAC Ambulance service',
        defaultMessage: 'ADAC Ambulance Service'
    },
    telefonLabel: {
        id: 'adac.header.modal-contact-adac.Phone Label',
        defaultMessage: 'Telephone number'
    },
    emailLabel: {
        id: 'adac.header.modal-contact-adac.Email Label',
        defaultMessage: 'E-Mail Address'
    }
});
